export const POSITION = {
  topCenter: 'topCenter',
  bottomCenter: 'bottomCenter',
  topLeft: 'topLeft',
  topRight: 'topRight',
  bottomLeft: 'bottomLeft',
  bottomRight: 'bottomRight',
}

/**
 * 默认情感图标
 */
export const DefaultIconMap = {
  primary: 'info-circle-s',
  secondary: 'info-circle-s',
  success: 'check-circle-s',
  warning: 'exclamation-circle-s',
  danger: 'times-circle-s',
}
